export default {
    activityLogs: [],
    currentActivityLog: null,
};
